export default "__VITE_ASSET__BfG6SqMS__"